<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
  <p class="text-load">&nbsp;&nbsp; Loading...</p>
</div>

<div class="schedule-body">

  <!-- Row 1: Schedule ID | Accenture Operations Service Line | (empty) -->
  <div class="form-row">
    <div class="form-field">
      <label class="field-label">Schedule ID</label>
      <input type="text" class="field-input field-input--readonly"
        [value]="scheduleId" readonly tabindex="-1" />
    </div>

    <div class="form-field">
      <label class="field-label">Accenture Operation Service Line</label>
      <div class="custom-select service-line-select"
        [class.custom-select--open]="serviceLineDropdownOpen">
        <div class="custom-select__display"
          [class.custom-select__display--readonly]="isReadonly"
          (click)="toggleServiceLineDropdown()"
          [class.placeholder]="form.serviceLines.length === 0">
          @if (form.serviceLines.length === 0) {
            <span class="custom-select__text">Select Accenture Operation Service Line</span>
          } @else {
            <span class="custom-select__chips">
              @for (selected of form.serviceLines; track selected) {
                <span class="service-line-chip">
                  {{ selected }}
                  @if (!isReadonly) {
                    <button type="button" class="service-line-chip__remove"
                      aria-label="Remove"
                      (click)="removeServiceLine(selected, $event)">&times;</button>
                  }
                </span>
              }
            </span>
          }
          <span class="custom-select__chevron">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>
        @if (serviceLineDropdownOpen) {
          <ul class="custom-select__list">
            @for (option of serviceLineOptions; track option) {
              <li class="custom-select__option"
                [class.custom-select__option--selected]="isServiceLineSelected(option)"
                (mousedown)="$event.preventDefault(); toggleServiceLine(option)">
                {{ option }}
              </li>
            }
          </ul>
        }
      </div>
      <p class="sl-helper">
        If the Accenture Operation Service Line you are looking for is not present in the dropdown,
        <a [routerLink]="['/request']" class="sl-helper__link">click here</a>
        to request to add New Accenture Operation Service Line to Admin — Request &gt; New Request &gt; Accenture Operation Service Line
      </p>
    </div>

    <div class="form-field"></div>
  </div>

  <!-- Row 2: Parent/Child | Parent Review ID | Go-Live Date (Go-Live) or empty (standard) -->
  <div class="form-row">
    <div class="form-field">
      <label class="field-label">Parent/Child</label>
      <div class="custom-select parent-child-select"
        [class.custom-select--open]="parentChildDropdownOpen">
        <div class="custom-select__display"
          [class.custom-select__display--readonly]="parentChildReadonly || isReadonly"
          (click)="toggleParentChildDropdown()"
          [class.placeholder]="!form.parentChild">
          <span class="custom-select__text">{{ form.parentChild || 'Select' }}</span>
          <span class="custom-select__chevron">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>
        @if (parentChildDropdownOpen) {
          <ul class="custom-select__list">
            @for (option of parentChildOptions; track option) {
              <li class="custom-select__option custom-select__option--grey-hover"
                [class.custom-select__option--selected]="form.parentChild === option"
                (mousedown)="$event.preventDefault(); selectParentChild(option)">
                {{ option }}
              </li>
            }
          </ul>
        }
      </div>
    </div>

    @if (showParentReviewId) {
      <div class="form-field">
        <label class="field-label">Parent Review ID<span *ngIf="!isParentLocation" class="required"> *</span></label>
        <div class="custom-select parent-review-id-select"
          [class.custom-select--open]="parentReviewIdDropdownOpen">
          <div class="custom-select__display"
            [class.custom-select__display--readonly]="isReadonly"
            [class.custom-select__display--error]="!!parentReviewIdError"
            (click)="toggleParentReviewIdDropdown()"
            [class.placeholder]="!form.parentReviewId">
            <span class="custom-select__text">{{ form.parentReviewId || 'Select' }}</span>
            <span class="custom-select__chevron">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </span>
          </div>
          @if (parentReviewIdDropdownOpen) {
            <div class="searchable-dropdown" (click)="$event.stopPropagation()">
              <input type="text" class="searchable-dropdown__search"
                [(ngModel)]="parentReviewIdSearchTerm" placeholder="Search..." />
              <ul class="searchable-dropdown__list">
                @for (option of filteredParentReviewIdOptions; track option) {
                  <li [class.selected]="form.parentReviewId === option"
                    (mousedown)="$event.preventDefault(); selectParentReviewId(option)">
                    {{ option }}
                  </li>
                }
                @if (filteredParentReviewIdOptions.length === 0) {
                  <li class="no-results">No matches</li>
                }
              </ul>
            </div>
          }
        </div>
        @if (parentReviewIdError) {
          <p class="field-error">{{ parentReviewIdError }}</p>
        }
      </div>
    } @else {
      <div class="form-field"></div>
    }

    <!-- Third column: Go-Live Date for Go-Live reviews, empty for standard -->
    @if (isGoLive) {
      <div class="form-field">
        <label class="field-label">
          Go-Live Date
          <span class="required">*</span>
          <span class="info-icon" data-tooltip="Enter the confirmed Go-Live Date">i</span>
        </label>
        <div class="date-input">
          @if (datesReadonly) {
            <input type="text" class="field-input field-input--readonly"
              [value]="glLiveDateDisplay" readonly tabindex="-1" />
          } @else {
            <div class="date-picker-field">
              <input type="text" class="field-input field-input--with-icon"
                placeholder="DD-MMM-YYYY" maxlength="11"
                [class.field-input--error]="!!goLiveDateError"
                [ngModel]="goLiveDateText"
                (ngModelChange)="onGoLiveDateTextChange($event)" />
              <button type="button" class="date-picker-btn"
                (click)="openDatePicker(glDatePickerRef?.nativeElement)" aria-label="Open calendar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b0ac9" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="3" y1="9" x2="21" y2="9" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                </svg>
              </button>
              @if (glDatePickerMounted) {
                <input #glDatePicker type="date" class="date-picker-native"
                  tabindex="-1" aria-hidden="true"
                  [value]="form.goLiveDate"
                  (change)="onGoLiveDatePicked(glDatePicker.value)" />
              }
            </div>
          }
        </div>
        @if (goLiveDateError) {
          <p class="field-error">{{ goLiveDateError }}</p>
        }
      </div>
    } @else {
      <div class="form-field"></div>
    }
  </div>

  <!-- ── Go-Live specific rows ─────────────────────────────────────────── -->
  @if (isGoLive) {

    <!-- Pre Go-Live row: only for "Pre and Post Go-Live" subtype -->
    @if (isPreAndPost) {
      <div class="form-row">

        <!-- GLRR Interim Call Date (read-only, mirrors Pre Go-Live FW End Date) -->
        <div class="form-field">
          <label class="field-label">
            GLRR-interim Call Date (Pre Go-Live FW End Date)
            <span class="info-icon" data-tooltip="20 working days prior Go-Live date">i</span>
          </label>
          <input type="text" class="field-input field-input--readonly"
            [value]="glrrInterimCallDate" readonly tabindex="-1" />
        </div>

        <!-- Pre Go-Live Fieldwork Start Date -->
        <div class="form-field">
          <label class="field-label">
            Pre Go-Live Fieldwork Start Date
            <span class="required">*</span>
            <span class="info-icon" data-tooltip="The formula automatically sets the Pre Go-Live Fieldwork Start Date to 55 Working Business Days prior to the Go-Live Date.">i</span>
          </label>
          <div class="date-input">
            @if (datesReadonly) {
              <input type="text" class="field-input field-input--readonly"
                [value]="preGoLiveFWStartDisplay" readonly tabindex="-1" />
            } @else {
              <div class="date-picker-field">
                <input type="text" class="field-input field-input--with-icon"
                  placeholder="DD-MMM-YYYY" maxlength="11"
                  [class.field-input--error]="!!preGoLiveFWStartDateError"
                  [ngModel]="preGoLiveFWStartDateText"
                  (ngModelChange)="onPreGoLiveFWStartTextChange($event)" />
                <button type="button" class="date-picker-btn"
                  (click)="openDatePicker(preStartPickerRef?.nativeElement)" aria-label="Open calendar">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b0ac9" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <line x1="3" y1="9" x2="21" y2="9" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                  </svg>
                </button>
                @if (preStartPickerMounted) {
                  <input #preStartPicker type="date" class="date-picker-native"
                    tabindex="-1" aria-hidden="true"
                    [value]="form.preGoLiveFWStartDate"
                    (change)="onPreGoLiveFWStartPicked(preStartPicker.value)" />
                }
              </div>
            }
          </div>
          @if (preGoLiveFWStartDateError) {
            <p class="field-error">{{ preGoLiveFWStartDateError }}</p>
          }
        </div>

        <!-- Pre Go-Live Fieldwork End Date -->
        <div class="form-field">
          <label class="field-label">
            Pre Go-Live Fieldwork End Date
            <span class="required">*</span>
            <span class="info-icon" data-tooltip="20 working days prior Go-Live date">i</span>
          </label>
          <div class="date-input">
            @if (datesReadonly) {
              <input type="text" class="field-input field-input--readonly"
                [value]="preGoLiveFWEndDisplay" readonly tabindex="-1" />
            } @else {
              <div class="date-picker-field">
                <input type="text" class="field-input field-input--with-icon"
                  placeholder="DD-MMM-YYYY" maxlength="11"
                  [class.field-input--error]="!!preGoLiveFWEndDateError"
                  [ngModel]="preGoLiveFWEndDateText"
                  (ngModelChange)="onPreGoLiveFWEndTextChange($event)" />
                <button type="button" class="date-picker-btn"
                  (click)="openDatePicker(preEndPickerRef?.nativeElement)" aria-label="Open calendar">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b0ac9" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <line x1="3" y1="9" x2="21" y2="9" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                  </svg>
                </button>
                @if (preEndPickerMounted) {
                  <input #preEndPicker type="date" class="date-picker-native"
                    tabindex="-1" aria-hidden="true"
                    [value]="form.preGoLiveFWEndDate"
                    (change)="onPreGoLiveFWEndPicked(preEndPicker.value)" />
                }
              </div>
            }
          </div>
          @if (preGoLiveFWEndDateError) {
            <p class="field-error">{{ preGoLiveFWEndDateError }}</p>
          }
        </div>

      </div>
    }

    <!-- Post Go-Live row: Publish Final Report | Post FW Start | Post FW End -->
    <div class="form-row">

      <!-- Publish Final Report (formula-calculated, read-only) -->
      <div class="form-field">
        <label class="field-label">
          Publish Final Report
          <span class="info-icon" data-tooltip="30 Working Business Days(single Review) 45 Days (Global) From Post-Go-Live End Of Field Work ( Complete Post Go-Live Testing)">i</span>
        </label>
        <input type="text" class="field-input field-input--readonly"
          [value]="publishFinalReport" readonly tabindex="-1" />
        <p class="field-helper">
          Formula automatically calculates the target publication date by adding either 30 or 45 working
          days to the <strong>Post Go-Live Fieldwork End Date</strong>, depending on whether it's a
          single or multi-location review.
        </p>
      </div>

      <!-- Post Go-Live Fieldwork Start Date -->
      <div class="form-field">
        <label class="field-label">
          Post Go-Live Fieldwork Start Date
          <span class="required">*</span>
          <span class="info-icon" data-tooltip="10 Working Business days(WD)post Go-Live date">i</span>
        </label>
        <div class="date-input">
          @if (datesReadonly) {
            <input type="text" class="field-input field-input--readonly"
              [value]="postGoLiveFWStartDisplay" readonly tabindex="-1" />
          } @else {
            <div class="date-picker-field">
              <input type="text" class="field-input field-input--with-icon"
                placeholder="DD-MMM-YYYY" maxlength="11"
                [class.field-input--error]="!!postGoLiveFWStartDateError"
                [ngModel]="postGoLiveFWStartDateText"
                (ngModelChange)="onPostGoLiveFWStartTextChange($event)" />
              <button type="button" class="date-picker-btn"
                (click)="openDatePicker(postStartPickerRef?.nativeElement)" aria-label="Open calendar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b0ac9" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="3" y1="9" x2="21" y2="9" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                </svg>
              </button>
              @if (postStartPickerMounted) {
                <input #postStartPicker type="date" class="date-picker-native"
                  tabindex="-1" aria-hidden="true"
                  [value]="form.postGoLiveFWStartDate"
                  (change)="onPostGoLiveFWStartPicked(postStartPicker.value)" />
              }
            </div>
          }
        </div>
        @if (postGoLiveFWStartDateError) {
          <p class="field-error">{{ postGoLiveFWStartDateError }}</p>
        }
      </div>

      <!-- Post Go-Live Fieldwork End Date -->
      <div class="form-field">
        <label class="field-label">
          Post Go-Live Fieldwork End Date
          <span class="required">*</span>
          <span class="info-icon" data-tooltip="Select the end date for Post Go-Live fieldwork">i</span>
        </label>
        <div class="date-input">
          @if (datesReadonly) {
            <input type="text" class="field-input field-input--readonly"
              [value]="postGoLiveFWEndDisplay" readonly tabindex="-1" />
          } @else {
            <div class="date-picker-field">
              <input type="text" class="field-input field-input--with-icon"
                placeholder="DD-MMM-YYYY" maxlength="11"
                [class.field-input--error]="!!postGoLiveFWEndDateError"
                [ngModel]="postGoLiveFWEndDateText"
                (ngModelChange)="onPostGoLiveFWEndTextChange($event)" />
              <button type="button" class="date-picker-btn"
                (click)="openDatePicker(postEndPickerRef?.nativeElement)" aria-label="Open calendar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b0ac9" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="3" y1="9" x2="21" y2="9" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                </svg>
              </button>
              @if (postEndPickerMounted) {
                <input #postEndPicker type="date" class="date-picker-native"
                  tabindex="-1" aria-hidden="true"
                  [value]="form.postGoLiveFWEndDate"
                  (change)="onPostGoLiveFWEndPicked(postEndPicker.value)" />
              }
            </div>
          }
        </div>
        @if (postGoLiveFWEndDateError) {
          <p class="field-error">{{ postGoLiveFWEndDateError }}</p>
        }
      </div>

    </div>

  } @else {

    <!-- ── Standard review rows ────────────────────────────────────────── -->

    <!-- Row 3: Target for Report Publication | Fieldwork Start Date | Fieldwork End Date -->
    <div class="form-row">
      <div class="form-field">
        <label class="field-label">Target for Report Publication</label>
        <input type="text" class="field-input field-input--readonly"
          [value]="targetReportPublicationDate" readonly tabindex="-1" />
        <p class="field-helper">
          Formula automatically calculates the target publication date by adding either 30 or 45 days
          to the 'Fieldwork End' date, depending on whether it's a single or multi-location review.
        </p>
      </div>

      <div class="form-field">
        <label class="field-label">
          Fieldwork Start Date
          <span class="required">*</span>
        </label>
        <div class="date-input">
          @if (datesReadonly) {
            <input type="text" class="field-input field-input--readonly"
              [value]="fieldworkStartDateDisplay" readonly tabindex="-1" />
          } @else {
            <div class="date-picker-field">
              <input type="text" class="field-input field-input--with-icon"
                placeholder="DD-MMM-YYYY" maxlength="11"
                [class.field-input--error]="!!startDateError"
                [ngModel]="fieldworkStartDateText"
                (ngModelChange)="onStartDateTextChange($event)" />
              <button type="button" class="date-picker-btn"
                (click)="openDatePicker(startPickerRef?.nativeElement)" aria-label="Open calendar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b0ac9" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="3" y1="9" x2="21" y2="9" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                </svg>
              </button>
              @if (startPickerMounted) {
                <input #startPicker type="date" class="date-picker-native"
                  tabindex="-1" aria-hidden="true"
                  [value]="form.fieldworkStartDate"
                  (change)="onStartDatePicked(startPicker.value)" />
              }
            </div>
          }
        </div>
        @if (startDateError) {
          <p class="field-error">{{ startDateError }}</p>
        }
      </div>

      <div class="form-field">
        <label class="field-label">
          Fieldwork End Date
          <span class="required">*</span>
        </label>
        <div class="date-input">
          @if (datesReadonly) {
            <input type="text" class="field-input field-input--readonly"
              [value]="fieldworkEndDateDisplay" readonly tabindex="-1" />
          } @else {
            <div class="date-picker-field">
              <input type="text" class="field-input field-input--with-icon"
                placeholder="DD-MMM-YYYY" maxlength="11"
                [class.field-input--error]="!!endDateError"
                [ngModel]="fieldworkEndDateText"
                (ngModelChange)="onEndDateTextChange($event)" />
              <button type="button" class="date-picker-btn"
                (click)="openDatePicker(endPickerRef?.nativeElement)" aria-label="Open calendar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b0ac9" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="3" y1="9" x2="21" y2="9" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                </svg>
              </button>
              @if (endPickerMounted) {
                <input #endPicker type="date" class="date-picker-native"
                  tabindex="-1" aria-hidden="true"
                  [value]="form.fieldworkEndDate"
                  (change)="onEndDatePicked(endPicker.value)" />
              }
            </div>
          }
        </div>
        @if (endDateError) {
          <p class="field-error">{{ endDateError }}</p>
        }
      </div>
    </div>

  }

  <!-- Staffing validation message (always visible when roles are missing) -->
  @if (locationCards.length > 0 && hasMissingPrimaryRoles) {
    @if (showSubmitRoleError) {
      <p class="field-error staffing-error">
        Error: Primary R&amp;C Manager, Supervisor and Reviewer must be assigned for all locations before scheduling can be submitted.
      </p>
    } @else {
      <p class="staffing-warning staffing-error">
        Warning: One or more locations are missing a Primary R&amp;C Manager, Supervisor, or Reviewer. Please assign all three before submitting.
      </p>
    }
  }

  <!-- Action buttons -->
  <div class="action-buttons">
    <button type="button" class="action-cancel" (click)="onCancel()" [disabled]="isReadonly">Cancel</button>
    <span class="submit-btn-wrapper">
      <button type="button" class="action-submit" (click)="onSubmit()"
        [disabled]="isReadonly || basicDetailsDirty">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
        </svg>
        Submit
      </button>
      @if (basicDetailsDirty) {
        <span class="submit-tooltip">Please submit Review Basic Details before submitting Scheduling.</span>
      }
    </span>
  </div>
</div>

<!-- STD/ODR/SPR Fieldwork Date Changed popup -->
@if (!isGoLive && showFWDateChangedPopup) {
  <div class="gl-date-modal-overlay">
    <div class="gl-date-modal">

      <div class="gl-date-modal__header">
        <div class="gl-date-modal__header-left">
          <span class="gl-date-modal__warning-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" fill="#f59e0b"/>
              <line x1="12" y1="9" x2="12" y2="13" stroke="#1a2537" stroke-width="2" stroke-linecap="round"/>
              <circle cx="12" cy="17" r="1" fill="#1a2537"/>
            </svg>
          </span>
          <span class="gl-date-modal__title">Fieldwork Date Changed</span>
        </div>
        <button class="gl-date-modal__close" type="button" aria-label="Close"
          (click)="onCancelFWDateChange()">&#x2715;</button>
      </div>

      <div class="gl-date-modal__body">
        <p class="gl-date-modal__desc">
          You are about to change the Fieldwork {{ fwDateChangedFieldLabel }} Date.
          This will automatically recalculate all pending milestone dates across this review. This action cannot be undone.
        </p>

        <div class="gl-date-modal__actions">
          <button type="button" class="gl-date-modal__btn gl-date-modal__btn--cancel"
            (click)="onCancelFWDateChange()">Cancel</button>
          <button type="button" class="gl-date-modal__btn gl-date-modal__btn--recalc"
            (click)="onConfirmFWDateChange()">Confirm</button>
        </div>
      </div>

    </div>
  </div>
}

<!-- Go-Live Date Changed popup -->
@if (isGoLive && showGoLiveDateChangedPopup) {
  <div class="gl-date-modal-overlay">
    <div class="gl-date-modal">

      <div class="gl-date-modal__header">
        <div class="gl-date-modal__header-left">
          <span class="gl-date-modal__warning-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" fill="#f59e0b"/>
              <line x1="12" y1="9" x2="12" y2="13" stroke="#1a2537" stroke-width="2" stroke-linecap="round"/>
              <circle cx="12" cy="17" r="1" fill="#1a2537"/>
            </svg>
          </span>
          <span class="gl-date-modal__title">Go-Live Date Changed</span>
        </div>
        <button class="gl-date-modal__close" type="button" aria-label="Close"
          (click)="onCancelGoLiveDateChange()">&#x2715;</button>
      </div>

      <div class="gl-date-modal__body">
        <p class="gl-date-modal__desc">
          You have changed the <strong>Go-Live Date</strong>. The following dates were previously entered manually:
        </p>

        <div class="gl-date-modal__dates-box">
          @for (item of goLiveDateChangedAffectedDates; track item.label) {
            <div class="gl-date-modal__date-row">
              <span class="gl-date-modal__date-label">{{ item.label }}</span>
              <span class="gl-date-modal__date-pill">{{ item.value }}</span>
            </div>
          }
        </div>

        <div class="gl-date-modal__options">
          <div class="gl-date-modal__option gl-date-modal__option--keep">
            <div class="gl-date-modal__option-title">Keep My Dates as it is</div>
            <div class="gl-date-modal__option-desc">Your manually entered dates above will stay as they are. Nothing changes.</div>
          </div>
          <div class="gl-date-modal__option gl-date-modal__option--recalc">
            <div class="gl-date-modal__option-title">Recalculate from New Go-Live Date</div>
            <div class="gl-date-modal__option-desc">Both dates above will be replaced with new values calculated from the updated Go-Live Date.</div>
          </div>
        </div>

        <div class="gl-date-modal__actions">
          <button type="button" class="gl-date-modal__btn gl-date-modal__btn--cancel"
            (click)="onCancelGoLiveDateChange()">Cancel</button>
          <button type="button" class="gl-date-modal__btn gl-date-modal__btn--keep"
            (click)="onKeepMyDates()">Keep My Dates</button>
          <button type="button" class="gl-date-modal__btn gl-date-modal__btn--recalc"
            (click)="onRecalculate()">Recalculate</button>
        </div>
      </div>

    </div>
  </div>
}
